import { createGenericSaga } from "../../../../framework/sagas/sagaUtilities";
import { getApiRegistry } from "../../../../framework/state/apiRegistry";

export const notificationViewSagas = {
  getNotificationsMetadata: createGenericSaga(
    "notifications/getNotificationsMetadata",
    getApiRegistry().orderApi.apiOrderNotificationsMetadataGet.bind(getApiRegistry().orderApi)
  )
};
